define('home/templates/userChannels',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " hidden";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "<div data-role=\"email-verification-alert\"></div>\n\n<div class=\"spacing-bottom"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hideManagedChannels : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-role=\"managed-channels-wrapper\">\n<div class=\"card-wrap\" data-role=\"managed-channels\"></div>\n</div>\n\n<h2 class=\"text-subheading spacing-narrow\">"
    + container.escapeExpression(helpers.gettext.call(alias1,"Following",{"name":"gettext","hash":{},"data":data}))
    + "</h2>\n<div class=\"card-wrap\" data-role=\"followed-channels\"></div>\n";
},"useData":true})

});
